import { Link } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CTAFinal() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section ref={ref} className={`w-full flex flex-col lg:flex-row transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      {/* Left Panel */}
      <div className="w-full lg:w-1/2 relative h-[380px] md:h-[460px] lg:h-[520px] overflow-hidden">
        <img
          src="/images/008-cta-hosteleria-toldos.webp"
          alt="Terraza de restaurante con toldos en Málaga"
          title="Toldos para hostelería en Málaga"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/15 to-transparent"></div>
        <div className="absolute inset-0 flex flex-col justify-between p-8 md:p-12">
          <span className="text-white/80 text-xs font-label tracking-wider uppercase">
            Hostelería
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight max-w-md">
            Más mesas<br />a la sombra,<br />más clientes
          </h2>
        </div>
      </div>

      {/* Right Panel */}
      <div className="w-full lg:w-1/2 bg-background-50 flex flex-col items-center justify-center text-center px-6 md:px-12 py-14 md:py-16">
        <div className="max-w-md mx-auto flex flex-col items-center gap-6">
          <div className="w-16 h-16 rounded-2xl bg-primary-500/10 flex items-center justify-center mb-2">
            <i className="ri-customer-service-2-line text-primary-500 text-2xl"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight">
            ¿Hablamos de<br />tu toldo?
          </h2>
          <p className="text-base text-foreground-600 leading-relaxed">
            Cuéntanos qué necesitas y te damos un presupuesto sin compromiso en menos de 24 horas. Por teléfono, WhatsApp o con una visita.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-3 w-full max-w-sm pt-2">
            <a
              href="tel:+34951120770"
              className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 bg-foreground-900 text-white text-base font-semibold rounded-full hover:bg-primary-500 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-phone-line text-lg"></i>
              <span>951 12 07 70</span>
            </a>
            <a
              href="https://wa.me/34627213347"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full inline-flex items-center justify-center gap-2 px-6 py-4 bg-[#25D366] text-white text-base font-semibold rounded-full hover:bg-[#1fb855] transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              <span>WhatsApp</span>
            </a>
          </div>

          <Link
            to="/presupuesto"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors group whitespace-nowrap"
          >
            <span>O rellena el formulario de presupuesto</span>
            <i className="ri-arrow-right-line text-base group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}